import { NgFor, NgClass } from '@angular/common';
import { Component, OnInit, OnDestroy, HostListener, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-module-page',
imports: [NgFor, NgClass],
  templateUrl: './module-page.component.html',
  styleUrl: './module-page.component.scss'
})
export class ModulePageComponent implements OnInit, OnDestroy, AfterViewInit {
  isProfileOpen: boolean = false;
  userData: any;
  moduleListAcess: any;
  userDetails: any;
  profileImage: any;
  currentTime: string = '';
  currentDate: string = '';
  private timeInterval: any;

  @ViewChild('modulesScroll') private modulesScrollRef?: ElementRef<HTMLElement>;

  /** Maps vertical wheel to horizontal scroll; needs non-passive listener (see ngAfterViewInit). */
  private readonly onModulesWheel = (e: WheelEvent) => {
    const el = e.currentTarget as HTMLElement;
    if (el.scrollWidth <= el.clientWidth) {
      return;
    }
    if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
      return;
    }
    el.scrollLeft += e.deltaY;
    e.preventDefault();
  };

  modules = [
    {
      id: 55,
      title: 'Master Admin',
      image: '/assets/Frame 1430103506.svg',
      //url: "https://kga-masteradmin-webapp-dev-f6a3hxbkbnefeuff.centralindia-01.azurewebsites.net/"
    },
    {
      id: 55,
      title: 'Point Of Sale',
      image: '/assets/Frame 1430103506 (1).svg'
    },
    {
      id: 55,
      title: 'Membership',
      image: '/assets/Frame 1430103506 (2).svg'
    },
    {
      id: 55,
      title: 'Tournament',
      image: '/assets/Frame 1430103506 (3).svg'
    },
    {
      id: 55,
      title: 'F & B Web App',
      image: '/assets/Frame 1430103506.svg'
    }
  ];

  getCardOffsetClass(index: number): string {
    const total = this.modules.length;

    if (total === 2) {
      return index === 0 ? 'medium' : 'high';
    }

    if (total === 3) {
      return index === 1 ? 'high' : 'medium';
    }

    if (total === 4) {
      switch (index) {
        case 0:
        case 2:
          return 'medium';
        case 1:
        case 3:
          return 'high';
      }
    }

    if (total === 5) {
      switch (index) {
        case 0:
        case 4:
          return 'low';
        case 1:
        case 3:
          return 'medium';
        case 2:
          return 'high';
      }
    }

    // Default fallback (e.g., for 1 card or more than 5)
    return 'medium';
  }

  toggleProfileDropdown(event: Event) {
    event.stopPropagation();
    this.isProfileOpen = !this.isProfileOpen;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('.profile-dropdown')) {
      this.isProfileOpen = false;
    }
  }

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute) {
    this.userData = localStorage.getItem('userDetails'); // Get data from localStorage
    let data = this.userData ? JSON.parse(this.userData) : null;
    this.userDetails = data;
    this.moduleListAcess = data?.modules || [];
    let authorizationToken = data?.sessionToken;

    if (this.moduleListAcess && this.moduleListAcess.length == 1) {
      const url = `http://localhost:50576/?token=${authorizationToken}&id=${data?.adminUser.adminUserId}`;
    }
  }

  ngOnInit() {
    this.updateTimeAndDate();
    // Update time every minute
    this.timeInterval = setInterval(() => {
      this.updateTimeAndDate();
    }, 60000);
  }

  ngAfterViewInit() {
    const el = this.modulesScrollRef?.nativeElement;
    if (el) {
      el.addEventListener('wheel', this.onModulesWheel, { passive: false });
    }
  }

  ngOnDestroy() {
    const el = this.modulesScrollRef?.nativeElement;
    if (el) {
      el.removeEventListener('wheel', this.onModulesWheel);
    }
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
    }
  }

  updateTimeAndDate() {
    const now = new Date();
    
    // Format time as HH:MM
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    this.currentTime = `${hours}:${minutes}`;
    
    // Format date as "Day, DD MMM"
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    
    const dayName = days[now.getDay()];
    const day = now.getDate();
    const month = months[now.getMonth()];
    
    this.currentDate = `${dayName}, ${day} ${month}`;
  }

  logout() {
    window.location.href = environment.baseLoginUrl;
    localStorage.clear();
  }

  navigateApp(module: any) {
    let storedData = localStorage.getItem('userDetails'); // Get data from localStorage
    let userData = storedData ? JSON.parse(storedData) : null; // Parse only if data exists
    let authorizationToken = userData?.sessionToken ? userData.sessionToken : "123";
    let id = userData?.adminUser.adminUserId; // dynamically get this from your logic
    const url = `${module.moduleUrl}?token=${authorizationToken}&id=${id}&module=${module.moduleId}`;
  //  console.log(url);
    
    window.location.href = url
  }

  // Helper methods to map modules to card styles
  getGradientClass(index: number): string {
    const gradients = ['grad-membership', 'grad-pos-hub', 'grad-fb', 'grad-pos-setup', 'grad-admin', 'grad-golf'];
    return gradients[index % gradients.length] || 'grad-membership';
  }

  getMainImage(index: number): string {
    const images = [
      'https://c.animaapp.com/mjb434uzIGc6TG/img/mask-group-1.png',
      'https://c.animaapp.com/mjb434uzIGc6TG/img/mask-group-3.png',
  
      'https://c.animaapp.com/mjb434uzIGc6TG/img/mask-group-7.png',
          'https://c.animaapp.com/mjb434uzIGc6TG/img/mask-group-5.png',
      'https://c.animaapp.com/mjb434uzIGc6TG/img/mask-group-9.png',
      '/assets/color.png'
      
    ];
    return images[index % images.length] || images[0];
  }

  getReflectionImage(index: number): string {
    const reflections = [
      'https://c.animaapp.com/mjb434uzIGc6TG/img/mask-group.png',
      'https://c.animaapp.com/mjb434uzIGc6TG/img/mask-group-2.png',
   
      'https://c.animaapp.com/mjb434uzIGc6TG/img/mask-group-6.png',
         'https://c.animaapp.com/mjb434uzIGc6TG/img/mask-group-4.png',
      'https://c.animaapp.com/mjb434uzIGc6TG/img/mask-group-8.png',
      'https://c.animaapp.com/mjb434uzIGc6TG/img/mask-group-10.png'
    ];
    return reflections[index % reflections.length] || reflections[0];
  }

  getImageClass(index: number): string {
    const classes = ['img-1', 'img-2', 'img-3', 'img-4', 'img-5', 'img-6'];
    return classes[index % classes.length] || 'img-1';
  }

  getReflectionClass(index: number): string {
    const classes = ['ref-1', 'ref-2', 'ref-3', 'ref-4', 'ref-5', 'ref-6'];
    return classes[index % classes.length] || 'ref-1';
  }

  getCardTitle(module: any): string {
    if (!module || !module.moduleName) return '';
    // Split title at common break points
    const name = module.moduleName;
    if (name.includes('Membership')) {
      return 'Membership<br />Center';
    } else if (name.includes('POS') && name.includes('Hub')) {
      return 'POS<br />Hub';
    } else if (name.includes('F&B') || name.includes('F & B')) {
      return 'F&B<br />Console';
    } else if (name.includes('POS') && name.includes('Setup')) {
      return 'POS<br />Setup';
    } else if (name.includes('Admin')) {
      return 'Admin<br />Console';
    } else if (name.includes('Golf')) {
      return 'Golf<br />Admin';
    }
    // Default: try to split at space if title is long
    const words = name.split(' ');
    if (words.length > 1) {
      const mid = Math.ceil(words.length / 2);
      return words.slice(0, mid).join(' ') + '<br />' + words.slice(mid).join(' ');
    }
    return name;
  }
  
}
